import { WebPlugin } from '@capacitor/core';
export class PdfGeneratorWeb extends WebPlugin {
    async fromURL(_options) {
        throw this.unimplemented('fromURL is not available in the web implementation.');
    }
    async fromData(_options) {
        throw this.unimplemented('fromData is not available in the web implementation.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map